module.exports = __webpack_public_path__ + "static/media/H4_groot ontspanning.a5b3fd66.png";